import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import block from 'bem-cn';

import usePlayerStatistics from 'features/reports/hooks/usePlayerStatistics';

import './Statistics.scss';

const b = block('reports-player-statistics-desktop');

const Statistics = () => {
  const { currency } = useSelector(state => state.auth);
  const { details } = useSelector(state => state.reports.slotsHistory);
  const locale = useSelector(state => state.locale.locale);

  const data = usePlayerStatistics()

  return (
    <div className={b()}>
      <h3 className={b('title')}>{locale.total}</h3>
      <div className={b('content')}>
        <div className={b('item')}>
          <div className={b('item-title')}>{locale.totalBetCount}</div>
          <div className={b('item-value')}>
            <span className={b('item-amount')}>{data.totalBetCount}</span>
          </div>
        </div>
        <div className={b('item')}>
          <div className={b('item-title')}>{locale.totalBet}</div>
          <div className={b('item-value')}>
            <span className={b('item-amount')}>{data.totalBet}</span>
            <span className={b('item-currency')}>{currency}</span>
          </div>
        </div>
        <div className={b('item')}>
          <div className={b('item-title')}>{locale.totalWon}</div>
          <div className={b('item-value')}>
            <span className={b('item-amount')}>{data.totalWon}</span>
            <span className={b('item-currency')}>{currency}</span>
          </div>
        </div>
        <div className={b('item')}>
          <div className={b('item-title')}>{locale.netwin}</div>
          <div className={b('item-value')}>
            <span className={b('item-amount')}>{data.netwin}</span>
            <span className={b('item-currency')}>{currency}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statistics;
